import React from 'react'
import styled from '@emotion/styled'
import { withTheme } from 'emotion-theming'
import { array, object } from 'prop-types'

// import Components
import CardLong from 'components/CardLongCta'
import { Article, PriceQuotes, ProductServiceReviews as Reviews } from '@jelly/components'

// styled components
const OfferingWrapper = styled.div`
	height: 100%;
	max-width: 100%;
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	${({ theme }) => theme.MQ.M} {
		max-width: 50%;
		min-height: 600px;
	}
`

CoreOfferings.propTypes = {
	coreOfferings: array.isRequired,
	theme: object.isRequired,
}

/**
 * This is the core offerings component for the review landing page
 * Contains three offering cards
 */
function CoreOfferings({ theme, coreOfferings }) {
	return (
		<OfferingWrapper>
			<CardLong
				background="#1a8699"
				cta={coreOfferings[0].title}
				description={coreOfferings[0].description}
				icon={<Article stroke="#ffffff" width="40%" />}
				path={coreOfferings[0].canonical}
			/>
			<CardLong
				background={theme.colors.tertiary}
				cta={coreOfferings[1].title}
				description={coreOfferings[1].description}
				icon={<Reviews stroke="#ffffff" width="50%" />}
				path={coreOfferings[1].canonical}
			/>
			<CardLong
				background="#1a8699"
				cta={coreOfferings[2].title}
				description={coreOfferings[2].description}
				icon={<PriceQuotes stroke="#ffffff" width="30%" />}
				path={coreOfferings[2].canonical}
			/>
		</OfferingWrapper>
	)
}
export default withTheme(CoreOfferings)
